import type { SpKycMode } from '@/features/kyc-config'
import { isRedeemEnabled } from './rewards-guards'

export type RedeemGateProfile = {
  ekycStatus?: string
} | null | undefined

function isEkycVerified(profile: RedeemGateProfile): boolean {
  return profile?.ekycStatus === 'verified'
}

/** Redeem CTA enabled (BFP-1025 / BFP-1119) — mirrors mobile `RewardsRedeemGate`. */
export function isRedeemCtaEnabled(args: {
  availableBalanceUsd: number | undefined
  redeemFulfillmentAvailable?: boolean
  profile: RedeemGateProfile
  tenantKycMode?: SpKycMode
}): boolean {
  const summaryOk = isRedeemEnabled(
    args.availableBalanceUsd,
    args.redeemFulfillmentAvailable ?? true,
  )
  const mode = args.tenantKycMode ?? 'unknown'
  if (mode === 'unknown') return false
  if (mode === 'disabled') return summaryOk
  if (!isEkycVerified(args.profile)) return false
  return summaryOk
}

/** Block navigation / submit when tenant KYC is enabled and SP is not verified. */
export function shouldBlockRedeemForTenantEkyc(
  tenantKycMode: SpKycMode | undefined,
  profile: RedeemGateProfile,
): boolean {
  const mode = tenantKycMode ?? 'unknown'
  if (mode === 'disabled') return false
  if (mode === 'unknown') return true
  return !isEkycVerified(profile)
}
